import MaterialRadioGroup, { RadioGroupProps } from '@mui/material/RadioGroup';

export function RadioGroup(props: RadioGroupProps) {
    return (
        <MaterialRadioGroup data-testid={'RadioGroup-container'} {...props} />
    );
}

export default RadioGroup;
